import { createFileRoute } from "@tanstack/react-router";

import CalculatorPage, { DarkThemeLayout } from "./-components/CalculatorPage";

export const Route = createFileRoute("/_app/calculator")({
  component: Calculator,
});

/**
 * Not a child of `_dashboard`: the pricing calculator is a marketing surface
 * that renders dark, with no dashboard chrome. The theme has to sit above the
 * page, which reads it through `useTheme`.
 */
function Calculator() {
  return (
    <DarkThemeLayout>
      <CalculatorPage />
    </DarkThemeLayout>
  );
}
